import React from "react";
import { withStyles } from "@material-ui/core/styles";
import createStyles from "@material-ui/core/styles/createStyles";
import { Theme } from "@material-ui/core/styles/createMuiTheme";
import Typography from "@material-ui/core/Typography";

const styles = (theme: Theme) =>
  createStyles({
    header: {
      backgroundColor: theme.palette.primary.main,
      padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 4}px`,
      borderRadius: "5px 5px 0 0",
      color: "#FFF",
    },
    titleRow: {
      display: "flex",
      alignItems: "baseline",
      flexWrap: "nowrap",
      overflow: "hidden",
      whiteSpace: "nowrap",
      "@media (min-width:600px) and (orientation: landscape)": {
        lineHeight: 1.2,
        fontSize: "1.2rem",
      },
    },
    titleMain: {
      flexShrink: 0,
    },
    titleSeparator: {
      flexShrink: 0,
      color: "rgba(255, 255, 255, 0.55)",
      margin: "0 0.35em",
      fontSize: "0.85rem",
    },
    subtitle: {
      flex: "1 1 auto",
      minWidth: 0,
      overflow: "hidden",
      textOverflow: "ellipsis",
      fontWeight: 400,
      fontSize: "1rem",
      color: "rgba(255, 255, 255, 0.75)",
    },
    info: {
      marginLeft: "auto",
      flex: "0 1 auto",
    },
  });

interface PropsTypes {
  classes: any;
  children: any;
  subtitle?: React.ReactNode;
  info?: React.ReactNode;
}

const UiFormTitle = (props: PropsTypes) => {
  const { classes, children, subtitle, info } = props;
  return (
    <header className={classes.header}>
      <Typography variant="h5" color="inherit" className={classes.titleRow}>
        <span className={classes.titleMain}>{children}</span>
        {subtitle ? (
          <>
            <span className={classes.titleSeparator}>·</span>
            <span className={classes.subtitle}>{subtitle}</span>
          </>
        ) : null}
        {info ? (
          <span className={`${classes.subtitle} ${classes.info}`}>{info}</span>
        ) : null}
      </Typography>
    </header>
  );
};

export default withStyles(styles)(UiFormTitle);
